import React from 'react';

/**
 * Top toolbar: search input + "Add New Password Entries" button.
 * Also shows an optional toast and an optional error banner.
 */
export default function Toolbar({
  searchTerm,
  onSearchChange,
  onOpenBulkForm,
  bulkButtonDisabled = false,
  toastMessage = null,
  errorMessage = null,
}) {
  return (
    <>
      {/* Toast */}
      {toastMessage && (
        <div
          style={{
            position: 'fixed',
            top: '1rem',
            right: '1rem',
            zIndex: 9999,
            backgroundColor: '#333',
            color: '#fff',
            padding: '8px 12px',
            borderRadius: '4px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
          }}
        >
          {toastMessage}
        </div>
      )}

      {/* Error */}
      {errorMessage && (
        <div className="alert alert-danger py-2 mb-2">
          {String(errorMessage)}
        </div>
      )}

      <div className="row g-2 mb-2">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search user code, full name, email, phone, or Slack ID..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            style={{ fontSize: '13px', height: '30px' }}
          />
        </div>
        <div className="col-md-8">
          <button
            className="btn btn-primary btn-sm"
            onClick={onOpenBulkForm}
            disabled={bulkButtonDisabled}
          >
            Add New Password Entries
          </button>
        </div>
      </div>
    </>
  );
}
